import createModel, { prop } from './lib/create_model';

import CustomerViewerActivity from './customer_viewer_activity';
import CustomerViewerActivityTarget from './customer_viewer_activity_target';

/**
 * CustomerViewer is one other Agent Desktop session that is on the same customer
 * page as us right now. One agent can have the customer open in two tabs, so
 * callers that render per-agent group these by `agentId` rather than assuming one
 * record each.
 *
 * `id` is agent-and-session rather than session alone, and the agent half is
 * load-bearing: only the agent segment of the topic is bound by the broker to the
 * publisher, and every subscriber sees its colleagues' session ids on the topic.
 * Keyed on the session alone, an agent could publish under its own agent segment
 * into a colleague's slot and overwrite the record there.
 */
const CustomerViewer = createModel({
  modelName: 'CustomerViewer',

  properties: {
    id: prop(String).isRequired,
    agentId: prop(String).isRequired,
    activity: prop(String)
      .oneOf(...Object.values(CustomerViewerActivity))
      .default(CustomerViewerActivity.VIEWING),
    // Only set for activities that act on something, so it's absent for VIEWING —
    // left unconstrained by a default for that reason.
    activityTarget: prop(String).oneOf(...Object.values(CustomerViewerActivityTarget)),
    arrivedAt: prop(String),
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },

    // Both halves come from topic segments, which cannot contain the separator.
    idFor(agentId, sessionId) {
      return `${agentId}/${sessionId}`;
    },
  },
});

export default CustomerViewer;
